<div appModal (closeModal)="close()">
  <div loginForm [showCreateAccount]="showCreateAccount" (loginSuccess)="close()" (goToSignup)="showSignup()"></div>
</div>
